import axios from 'axios';

import type {
  IUserSearchDetailsRequest,
  IUserSearchDetailsQuery,
  IUserSearchDetailsResponse,
} from '@/app-package';

const getSearchDetails = async ({
  id,
  uid,
  listingId,
  reason,
  boardId,
}: IUserSearchDetailsQuery) => {
  const config: IUserSearchDetailsRequest = {
    url: '/user/search/details',
    method: 'get',
    params: { id, uid, listingId, reason, boardId },
  };

  const { data } = await axios.request<IUserSearchDetailsResponse>(config);

  return data;
};

export default getSearchDetails;
